

	import { Component } from 'vue-property-decorator';
	import { BaseView } from '@shared/views/BaseView';
	import { Company, Account, SubjectAggregate, Artist, Pro } from '@shared/models';
	import CompanyDecks from './CompanyDecks.vue';
	import CompanyPros from './CompanyPros.vue';
	import AccountList from '../../common/AccountList.vue';
	import ProItemList from '../pros/ProItemList.vue';
	import ArtistItemList from '../artists/ArtistItemList.vue';
	import PopularCompaniesWidget from './PopularCompaniesWidget.vue';
	import TopCategoriesByCompany from '@client/views/products/collections/TopCategoriesByCompany.vue';

	@Component({
		components: {
			CompanyDecks,
			CompanyPros,
			AccountList,
			TopCategoriesByCompany,
			ArtistItemList,
			ProItemList,
			PopularCompaniesWidget,
		},
	})
	export default class CompanyDetails extends BaseView {

		public model: Company = new Company();
		public modelId: string = '';
		public accounts: Account[] = [];
		public topArtists: Array<SubjectAggregate<Artist>> = new Array<SubjectAggregate<Artist>>();
		public topPros: Array<SubjectAggregate<Pro>> = new Array<SubjectAggregate<Pro>>();
		public yearList: number[] = [];
		public showFiller: boolean = false;
		public backgroundImage: string = '';

		public async mounted() {
			if (this.$route.name === 'company-details' ) { this.$router.push({ name: 'company-decks', params: { id: this.$route.params.id }}); }
			this.loading = true;
			try {
				this.modelId = this.$route.params.id;
				this.model = await this.$api.companyService.get(this.modelId);
				this.backgroundImage = 'https://lurker.blob.core.windows.net/companies/d_comp_' + this.model.id + '.jpg';
				this.setTitle(`Skate Lurker - ${this.model.name}  Skate Company`);
				this.accounts = await this.$api.companyAccountService.list(this.model.id);
				this.topArtists = (await this.$api.artistService.listByCompanyWithCount(this.model.id, 0, 4)).results;
				this.topPros = (await this.$api.proService.listByCompanyWithCount(this.model.id, 0, 4)).results;

				let widgetCount = 0;
				if (this.accounts && this.accounts.length) { widgetCount++; }
				if (this.topArtists && this.topArtists.length) { widgetCount++; }
				if (this.topPros && this.topPros.length) { widgetCount++; }
				this.showFiller = false;
				if (widgetCount < 2) { this.showFiller = true; }
				
			} catch (err) {
				if (err != null && err.request != null && err.request.status === 404) {
					this.$router.push({ name: '404', query: { type: 'company' }});
				} else {
					this.errorMessage = 'An error occurred while loading this company';
					this.errorHandler.handle(err, this.errorMessage);
				}
			} finally {
				this.loading = false;
			}
		}

		/** Fires when an image file cannot be found */
		public handleBrokenImage($event: any) {
			$event.target.src = `${this.settings.baseUrl}/Assets/Stubs/default-company.jpg`;
		}


	}

